import { render } from "./EditStockOpname.vue?vue&type=template&id=1a477f4b"
import script from "./EditStockOpname.vue?vue&type=script&lang=js"
export * from "./EditStockOpname.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__